import $ from "jquery"
import { trace } from "./../shared/helpers.js"
import UMasonry from "./../shared/UMasonry";
import UFilters from "./../calendar/UFilters";
import Contact from "./../shared/Contact";
import BluimpExtend from "./../shared/BluimpExtend";
import Catalogue from "./../catalogue/Catalogue";
import Horizonav from "./../horizonav/Horizonav";


const AjaxLoader = {

  asAnimationDelay : 200,
  asAnimationTimeout : null,
  useWindowHistory: true,
  ajaxStore: [],


  storeResult(url, $result) {    
    this.ajaxStore.push({url, $result});
  },
  getStoredResult(url) {
    let result = false;
    this.ajaxStore.forEach( (r, index)=> {      
      if (r.url == url) {        
        result = r.$result;
      }
    });
    return result;
  },


  handleResult($result) {
    $("html").addClass("as-loading");
    let $swap = $(".ajax-swap");
    $swap.addClass("as-loading");
    clearTimeout(this.asAnimationTimeout);
    this.asAnimationTimeout = setTimeout(()=> {
      $swap.each((index, el)=>{
        let id = $(el).attr("id");
        if (id) {
          let $fresh = $result.find("#" + id);
          if ($fresh.length) {
            $(el).html($fresh.html());
            $(el).removeClass("as-loading");
          }
        }
      });
      $("html").removeClass("as-loading");
      UMasonry.refresh();
      Contact.init();
      BluimpExtend.init();
      Catalogue.init();
      Horizonav.init();
    }, this.asAnimationDelay);

  },

  openURL(url) {
    let $r = this.getStoredResult(url);
    if ($r) {      
      this.handleResult($r);
    } else {
      this.loadURL(url);
    }
  },

  loadURL(url) {
    trace("AjaxLoader load: ", url);
    $("html").addClass("as-loading");
    let $swap = $(".ajax-swap");
    $swap.addClass("as-loading");
    $.get(url, {}, (result)=> {
      this.storeResult(url, $(result));
      this.handleResult($(result));      
    });
  },

  pushUrlState(url) {
    if (!this.useWindowHistory) {
      return false;
    }
    if (history) {
      history.pushState(null, null, url);
    }
  },

  init() {
    $("body").on("click", "[data-ajax]", (e)=> {      
      e.preventDefault();
      let $btn = $(e.currentTarget);
      let url = $btn.data("ajax");
      let filters = $btn.data("filters");
      if (filters) {
        url = UFilters.urlFilterParams(url);
      }
      this.openURL(url);
      // push state (URL update)
      if ($btn.attr("href")) {
        this.pushUrlState($btn.attr("href"));
      }
    });
  }

}

export default AjaxLoader;